import {get as _get} from 'lodash';

import {FIELD_REQUIRED} from '@constants/messages';

const isInvoiceStatusRequired = (row) => Boolean(row) && true !== row.auto_update;

export const validateInvoiceStatus = (value, allValues, props, name) => {
    const row = _get(allValues, name.substring(0, name.lastIndexOf('.')), null);

    if (isInvoiceStatusRequired(row) && !value) {
        return FIELD_REQUIRED;
    }
};

const validate = (values) => {
    const errors = {},
        rows = _get(values, 'invoice_statuses', []) || [],
        rowErrors = [];

    rows.forEach((row, index) => {
        if (isInvoiceStatusRequired(row) && !row.invoice_status) {
            rowErrors[index] = {invoice_status: FIELD_REQUIRED};
        }
    });

    if (rowErrors.length) {
        errors.invoice_statuses = rowErrors;
    }

    return errors;
};

export default validate;
